import ja from './ja';
import en from './en';
import fr from './fr';
import de from './de';
import es from './es';
import ko from './ko';

export default {
  ja,
  en,
  fr,
  de,
  es,
  ko,
};